export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'ws',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'wsk',
        sortField: 'wsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'superwsk',
        sortField: 'superwsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true,
    },
    {
        name: '__slot:ai_answer',
        type: 'string',
        dataClass: 'w300',
        useInFilter: false,
    },
    {
        name: 'created_at',
        sortField: 'created_at',
        type: 'dateRange',
        dataClass: 'ral',
        useInFilter: true,
        callback: 'fullDate',
    },
    {
        name: 'source_urls',
        type: 'string',
        callback: 'string',
        dataClass: 'ral',
        filterOnly: true,
        useInFilter: true,
        operatorsConfig: [
            {label: 'Содержит', condition: 'LIKE', component: 'string'},
            {label: 'Не содержит', condition: 'NOT LIKE', component: 'string'},
        ],
    },
]
